import React from 'react'
import { useDetalleSolicitudModel } from '../../../../modelos/Solicitudes/modeloSolicitud';
import { Send,} from 'lucide-react';

const NotificacionSolicitudes = ({solicitud}) => {
  const {
      enviarNotificacionSolciitud,
    } = useDetalleSolicitudModel();

  return (
    <div className="space-y-4">
      <div className="bg-white p-4 rounded-lg border">
        <h3 className="text-lg font-semibold mb-4">Enviar Notificación</h3>
        <div className="space-y-3">
          <button 
            onClick={() => {
              enviarNotificacionSolciitud(solicitud)
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
          >
            <Send size={16} className="inline mr-2" />
            Enviar Notificación
          </button>

        </div>
      </div>
    </div>
  )
}

export default NotificacionSolicitudes
